import { RenderableBase } from './renderable-base';

export class RenderableText extends RenderableBase<string> {
}
